// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"b5de7d3d","298":"deb1f25a","488":"bd5bdcb7","556":"29d5798e","567":"b1fccbdd","651":"a669b53a","788":"4ea9b06f","920":"4ad8fb58","977":"af934eb6"}[chunkId] + ".chunk.js";
};